export default "__VITE_ASSET__BMInoGNk__"